import { CheckIcon, PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import Input from "../../../../components/input";
import { CharityIssue, CharityIssueCategory } from "../../../../models";
import Container from "../../../../components/container";
import { addCharityIssue, State, updateCharityIssue } from "../actions/charity-issue";
import { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function CharityIssueUpdateForm({
  item,
  onCancel,
}: {
  item: CharityIssue;
  onCancel: () => void;
  
}) {
  const navigate = useNavigate();    
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };
  const updateCharityIssueWithId = updateCharityIssue.bind(null, item.id!);
  const [state, formAction, isPending] = useActionState(
    updateCharityIssueWithId,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate(`/admin/charity-issue-categories/edit/${item.charityIssueCategoryId}?reload=${Date.now()}`);
      toast.success("Charity issue updated successfully");
      onCancel();
    }
    else if (state.errors && Object.keys(state.errors).length > 0) {
      toast.error("Failed to update charity issue");
    }
  }, [state]);

  return (<td colSpan={2} className="px-6 py-4 bg-gray-100" >
    <form action={formAction} className="flex gap-2 w-full ">
      <Input
        className="w-full"
        name="name"
        id="name"
        placeholder="Name"
        required={true}
        defaultValue={item.name}
      ></Input>
      <input
        type="hidden"
        id="charityIssueCategoryId"
        name="charityIssueCategoryId"
        value={item.charityIssueCategoryId}
      ></input>
      <IconButton label="Update Charity Issue" icon={CheckIcon} loading={isPending}></IconButton>
      <IconButton type="button" label="Cancel" icon={XMarkIcon} onClick={onCancel}   ></IconButton>
    </form>
    </td>
  );
}
